mutation EntityEnvironmentalDocumentCreate($input: EntityEnvironmentalDocumentCreateInput!) {
  entityEnvironmentalDocumentCreate(
    input: $input
  ) {
    clientMutationId
    entityEnvironmental {
      id
      entityId
      description
      startDate
      endDate
      environmentalMetricId
      entityEnvironmentalItems {
        nodes {
          environmentalImpactTypeId
          feet
          gallons
          hours
          kilogram
          kilometers
          kilowattHours
          litres
          meters
          metricTonnes
          miles
          omissionsEquivalent
          pounds
          quantity
          therms
          tons
          yards
          carbonCreditsAmount
        }
      }
    }
  }
}
